import { render, staticRenderFns } from "./InformationSitting.vue?vue&type=template&id=50695516&"
import script from "./InformationSitting.vue?vue&type=script&lang=js&"
export * from "./InformationSitting.vue?vue&type=script&lang=js&"
import style0 from "./InformationSitting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports